import { CompanyAddressDto, PersonDto, VehicleDto } from 'dtos'
import * as yup from 'yup'

export class MichiganSOSBundleDto {
  michiganSOSBundleGuid?: string = undefined
  michiganTitleOwnerName?: string = undefined
  createdDateTime?: string = undefined
  createdByPerson?: PersonDto = undefined
  updatedDateTime?: string = undefined
  updatedByPerson?: PersonDto = undefined
  titleApplicationDeliveryPhotoUploadedDateTime?: string = undefined
  vehicleCount?: number = undefined
  bundleCompletedDateTime?: string = undefined
  isLocked?: boolean = undefined

  // This is used exclusively for the list.
  dropOffDate?: string
  dropOffTime?: string
  description?: string
  michiganSOSBranchCompanyAddress?: CompanyAddressDto
  vehicles?: VehicleDto[] = undefined
}

export const michiganSoSBundleValidationSchema = yup.object({
  michiganTitleOwnerName: yup.string().required('Owner is required.')
})
